import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "blocks",
  "use": "blocks-usage",
  "viewBox": "0 0 19 18",
  "content": "<symbol viewBox=\"0 0 19 18\" fill=\"inherit\" xmlns=\"http://www.w3.org/2000/svg\" id=\"blocks\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.6709 8.0573H10.6136V0H18.6709V8.0573ZM8.72894 8.0573H0.671638V0H8.72894V8.0573ZM0.671638 17.9998H8.72894V9.94248H0.671638V17.9998ZM18.6709 17.9998H10.6136V9.94248H18.6709V17.9998Z\" fill=\"inherit\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol